module.exports = __webpack_public_path__ + "img/title1_hover.fbde9b98.png";